<script>
    import Form from 'form-backend-validation';
    import moment from 'moment';

    export default {

        data() {
            return {
                success: false,
                error: false,
                errors: [],
                uuid: this.createUuid(),

                form: new Form({
                    _method: 'PUT',
                    display_name_preference: null,
                    avatar: null,
                    gender: '',
                    title: '',
                    firstname: '',
                    lastname: '',
                    birth_date: null,
                    phone: '',
                    mobile: '',
                    job_title: '',
                    is_rating_allowed: false,
                    newsletter: false,
                }, {
                    resetOnSuccess: false,
                }),
            }
        },

        props: ['model'],

        mounted() {
            const model = typeof this.model === 'string'
                ? JSON.parse(this.model)
                : this.model;

            this.form.populate(model);
        },

        computed: {
            datepickerClasses() {
                let classes = 'form-control';
                if (this.form.errors.has('birth_date')) {
                    classes += ' is-invalid';
                }
                return classes;
            }
        },

        methods: {

            formatDate(d){
                return moment( d, ['DD.MM.YYYY', 'YYYY-MM-DD'] ).format();
            },

            reset(event) {
                this.form.errors.clear(event.target.name);
                this.success = false;
            },

            onSubmit(){
                this.error = false;
                this.errors = [];
                if (this.form.birth_date instanceof Date) {
                    this.form.birth_date = this.formatDate(this.form.birth_date);
                }
                this.form.post('/profile')
                    .then(response => {
                        this.success = true;

                        // Update avatar images
                        $('.avatar > img').each(function(){
                            $(this).attr("src", response.avatar);
                        });
                        $('.profile-name').text(response.name);
                        this.scrollToFlushMessage();
                    })
                    .catch(error => {
                        this.error = true;
                        let errors = this.errors;
                        $.each(error.response.data.errors, function(index, value) {
                            errors.push({field:index,value:value+''});
                        });
                        this.scrollToFlushMessage();
                    });
            },

            scrollToFlushMessage() {
                $('html, body').animate({ scrollTop: ($('[data-id="'+this.uuid+'"]').offset().top-parseInt($("#pageHeader").height()))}, 'slow');
            },

            updateAvatar(e) {
                e.preventDefault();

                let files = this.$refs.avatar.files;
                this.form.avatar = files[0];
            },

            createUuid(){
                let dt = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid;
            }

        }
    }
</script>